import { SignInSettings } from '@rhino-project/ui-heroui';
import {
  prefetchApiKeys,
  prefetchAuthIdentities,
  prefetchPasskeys
} from '@rhino-project/core/queries';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_authenticated/$owner/account/settings/sign-in'
)({
  // Prefetch identities, passkeys, and API keys (all nested sections of
  // SignInSettings) so the page renders warm with no spinner flash.
  loader: ({ context: { rhino } }) =>
    Promise.all([
      prefetchAuthIdentities(rhino),
      prefetchPasskeys(rhino),
      prefetchApiKeys(rhino)
    ]),
  component: SignInSettings
});
